import { Text, useColorModeValue } from '@chakra-ui/react';
import i18next from 'i18next';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { BALANCE_RELOAD } from '../../constant';
import AnimateCount from '../../pages/WebSocket/components/AnimateCount';
import { gradientStyle } from '@/utils/styles.utils';

const BalanceAmount = ({ balanceStyle }) => {
  const walletCurrency = useSelector((state) => state.isWalletCurrency); //從redux store中取isWalletCurrency的值 存到walletCurrency變數中
  const isCurrencyExchange = useSelector((state) => state.isCurrencyExchange);
  const dispatch = useDispatch();

  const textColor = useColorModeValue('dark.100', 'light.100');

  const location = useLocation();

  const { pathname } = location;

  const { color, fontSize, fontWeight } = balanceStyle || {};

  useEffect(() => {
    const fetchDataPeriodically = () => {
      dispatch({ type: 'GET_BALANCE' });
    };

    const apiIterval = setInterval(() => {
      fetchDataPeriodically();
    }, BALANCE_RELOAD);

    return () => clearInterval(apiIterval);
  }, []);

  const balance = useMemo(() => {
    return isCurrencyExchange?.[walletCurrency]?.exchange_amount || 0;
  }, [walletCurrency, isCurrencyExchange]);

  return (
    <Text
      as="span"
      letterSpacing={'-3px'}
      sx={color || pathname.includes('gamebox') ? {} : gradientStyle}
      color={
        color ? color : pathname.includes('gamebox') ? 'white' : 'transparent'
      }
      fontSize={
        pathname.includes('gamebox')
          ? '18px'
          : {
              base: '1.4em',
              md: '1.8em'
            }
      } // 根據pathname判斷字體大小
      fontWeight={fontWeight}
    >
      {pathname.includes('gamebox') ? (
        `(${i18next.t('common.playing')})`
      ) : (
        <AnimateCount
          variant={{
            mass: 0.8,
            stiffness: 60,
            damping: 17.5
          }}
          value={balance}
        />
      )}
    </Text>
  );
};

export default BalanceAmount;
